module.exports = __webpack_public_path__ + "static/media/art-director.af513f1a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/features/art-director.mp4
// module id = 366
// module chunks = 0